import { ITEM_TYPES } from '@wix/advanced-seo-utils';
import { assertNever } from '@wix/seo-common-core';
import { useBlogPostsAltTextHandlers } from '../../../../../rule-mappers/rule-handlers/alt-text-v2/use-blog-posts-alt-text-rule-handlers';
import { useCategoriesAltTextHandlers } from '../../../../../rule-mappers/rule-handlers/alt-text-v2/use-categories-alt-text-handlers';
import { useEventsAltTextHandlers } from '../../../../../rule-mappers/rule-handlers/alt-text-v2/use-events-alt-text-handlers';
import { useGroupsAltTextHandlers } from '../../../../../rule-mappers/rule-handlers/alt-text-v2/use-groups-alt-text-rule-handlers';
import { useOnlineProgramsAltTextHandlers } from '../../../../../rule-mappers/rule-handlers/alt-text-v2/use-online-programs-alt-text-handlers';
import { usePortfolioCollectionsAltTextHandlers } from '../../../../../rule-mappers/rule-handlers/alt-text-v2/use-portfolio-collections-alt-text-rule-handlers';
import { usePortfolioProjectsAltTextHandlers } from '../../../../../rule-mappers/rule-handlers/alt-text-v2/use-portfolio-projects-alt-text-rule-handlers';
import { usePricingPlansAltTextHandlers } from '../../../../../rule-mappers/rule-handlers/alt-text-v2/use-pricing-plans-alt-text-handlers';
import { useProductsAltTextHandlers } from '../../../../../rule-mappers/rule-handlers/alt-text-v2/use-products-alt-text-handlers';
import { useRestaurantsMenuAltTextHandlers } from '../../../../../rule-mappers/rule-handlers/alt-text-v2/use-restaurants-menu-alt-text-handlers';
import { useServicesAltTextHandlers } from '../../../../../rule-mappers/rule-handlers/alt-text-v2/use-services-alt-text-handlers';
import { useStaticPagesAltTextHandlers } from '../../../../../rule-mappers/rule-handlers/alt-text-v2/use-static-pages-alt-text-handlers';
export const useGetAltTextHandlersFromItemType = _ref => {
  let {
    itemType
  } = _ref;
  const staticAltTextHandlers = useStaticPagesAltTextHandlers();
  const productAltTextHandlers = useProductsAltTextHandlers();
  const categoriesAltTextHandlers = useCategoriesAltTextHandlers();
  const blogPostsAltHandlers = useBlogPostsAltTextHandlers();
  const servicePageAltHandlers = useServicesAltTextHandlers();
  const eventAltTextHandlers = useEventsAltTextHandlers();
  const portfolioProjectsAltHandlers = usePortfolioProjectsAltTextHandlers();
  const portfolioCollectionsAltHandlers = usePortfolioCollectionsAltTextHandlers();
  const onlineProgramsAltHandlers = useOnlineProgramsAltTextHandlers();
  const groupAltHandlers = useGroupsAltTextHandlers();
  const pricingPlansAltHandlers = usePricingPlansAltTextHandlers();
  const restaurantsMenuAltHandlers = useRestaurantsMenuAltTextHandlers();
  switch (itemType) {
    case ITEM_TYPES.STATIC_PAGE_V2:
      return staticAltTextHandlers;
    case ITEM_TYPES.STORES_PRODUCT:
      return productAltTextHandlers;
    case ITEM_TYPES.STORES_CATEGORY:
      return categoriesAltTextHandlers;
    case ITEM_TYPES.BLOG_POST:
      return blogPostsAltHandlers;
    case ITEM_TYPES.BOOKINGS_SERVICE:
      return servicePageAltHandlers;
    case ITEM_TYPES.EVENTS_PAGE:
      return eventAltTextHandlers;
    case ITEM_TYPES.PORTFOLIO_PROJECTS:
      return portfolioProjectsAltHandlers;
    case ITEM_TYPES.PORTFOLIO_COLLECTIONS:
      return portfolioCollectionsAltHandlers;
    case ITEM_TYPES.CHALLENGES_PAGE:
      return onlineProgramsAltHandlers;
    case ITEM_TYPES.GROUPS_PAGE:
      return groupAltHandlers;
    case ITEM_TYPES.PRICING_PLANS:
      return pricingPlansAltHandlers;
    case ITEM_TYPES.RESTAURANTS_MENU_PAGE:
      return restaurantsMenuAltHandlers;
    default:
      assertNever(itemType);
  }
};
//# sourceMappingURL=use-get-alt-text-handlers-from-item-type.js.map